<router-outlet></router-outlet>

<!-- Toastr container -->
<app-toastr aria-live="polite" aria-atomic="true"></app-toastr>

<!-- spinner -->
<app-loader></app-loader>